import { KeyRound } from "lucide-react";
import type { Notify } from "./admin-types";
import { Header } from "./AdminPagePrimitives";

import { useAdminRolesWorkspace } from "./useAdminRolesWorkspace";

export function RolesPage({notify}: {notify: Notify}) {
  const { rows } = useAdminRolesWorkspace({notify});
  return (
    <>
      <Header
        eyebrow="Erişim modeli"
        title="Roller ve Yetkiler"
        description="Rollerin backend tarafından uygulanan yetki kapsamını inceleyin."
      />
      <section className="admin-role-grid">
        {rows.map((role) => (
          <article className="admin-role-card" key={role.code}>
            <div>
              <span className="admin-role-icon">
                <KeyRound size={17} />
              </span>
              <div>
                <h2>{role.name}</h2>
                <small>{role.code}</small>
              </div>
              <em>{role.user_count} kullanıcı</em>
            </div>
            <p>{role.description}</p>
            <div className="permission-chips">
              {role.permissions.map((permission) => (
                <span key={permission}>{permission}</span>
              ))}
            </div>
          </article>
        ))}
      </section>
    </>
  );
}
